export const humanizeDate = (dateStr) => {
  let options = {
    timeZone: "America/Asuncion",
    month: "long",
    year: "numeric",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  };

  let fmtDate = new Date(dateStr).toLocaleString("es-AR", options);
  fmtDate = fmtDate.replace(',', ' -');

  return `${fmtDate}hs`;
}

export const formatNumber = (number) => {
  return number ? Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '';
}

/**
 * @var items Array<T>
 */
export const sortByName = (items) => {

  return items?.sort(function(a, b) {
    const aName = a?.properties?.name || a.name;
    const bName = b?.properties?.name || b.name;

    if (aName > bName) {
      return 1;
    }
    if (aName < bName) {
      return -1;
    }

    return 0;
  }) || [];
}

export const getColor = (parcelProperties) => {
  switch (parcelProperties.status) {
    case 'public_space':
      return 0
    case 'sold':
      return 1
    case 'available':
      return 2
    case 'reserved':
      return 3
    default:
      return 0;
  }
}

export const unique = (data) => {
  function onlyUnique(value, index, self) {
    return self.map(item => item.id).indexOf(value.id) === index;
  }

  return data.filter(onlyUnique);
}
